import Seo from '../components/Seo';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Industries from '../components/Industries';
import Pricing from '../components/Pricing';
import TrainingPricing from '../components/TrainingPricing';
import PayrollPricing from '../components/PayrollPricing';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import { defaultMeta } from '../data';

export default function Home() {
  return (
    <>
      <Seo title={defaultMeta.title} description={defaultMeta.description} path="/" />
      <Hero />
      <About />
      <Services />
      <Industries />
      <Pricing />
      <TrainingPricing />
      <PayrollPricing />
      <FAQ />
      <Contact />
    </>
  );
}
